export const logos = {
  primary: require("./veckanse-logo-small-pink.png"),
  secondary: require("./veckans-logo-small.png")
}

export type LogoTypes = keyof typeof logos
